export default __webpack_public_path__ + "static/Sprial_2-fa9f6e7ae7129969f8fb63d715e5b8e6.mp4";